import { AgentWidgetAppearance, AgentWidgetLayout } from 'models'

/** An attribute of the element wins over the agent's setting, when it names a value of the enum. */
function resolveSetting<Value extends string>(
    values: readonly string[],
    attribute: string | undefined,
    setting: Value | undefined,
    fallback: Value,
): Value {
    if (attribute && values.includes(attribute)) {
        return attribute as Value
    }
    return setting ?? fallback
}

const LAYOUTS: readonly string[] = Object.values(AgentWidgetLayout)
const APPEARANCES: readonly string[] = Object.values(AgentWidgetAppearance)

/**
 * The layout the floating element shows (spec `widget-copilot.md`, D1): its
 * `layout` attribute wins over the agent's setting, and an attribute that
 * names no layout counts as absent.
 */
export function resolveWidgetLayout(
    attribute: string | undefined,
    setting: AgentWidgetLayout | undefined,
): AgentWidgetLayout {
    return resolveSetting(
        LAYOUTS,
        attribute,
        setting,
        AgentWidgetLayout.Floating,
    )
}

/** How the floating card looks over the site, with the same rule as the layout. */
export function resolveWidgetAppearance(
    attribute: string | undefined,
    setting: AgentWidgetAppearance | undefined,
): AgentWidgetAppearance {
    return resolveSetting(
        APPEARANCES,
        attribute,
        setting,
        AgentWidgetAppearance.Solid,
    )
}
